import styled from 'styled-components';
import { Tooltip as BaseTooltip } from '@reach/tooltip';
import { rgba } from 'polished';
import { c080820, c2A2A4D, cFFFFFF } from '#/colors';

const Tooltip = styled(BaseTooltip)`
  color: ${rgba(cFFFFFF, 0.7)};
  font-size: 11px;
  line-height: 16px;

  max-width: 230px;
  padding: 8px;
  border: 1px solid ${c2A2A4D};
  border-radius: 5px;
  background-color: ${c080820};
  white-space: normal;
`;

export default Tooltip;

export const HelpCursor = styled.span`
  cursor: help;
`;

export const HelpUnderline = styled.span`
  cursor: help;
  text-decoration: underline dotted 1px ${rgba(cFFFFFF, 0.3)};
  text-underline-offset: 3px;
`;

export const HelpUnderlineHover = styled.span`
  cursor: help;
  &:hover {
    text-decoration: underline dotted 1px ${rgba(cFFFFFF, 0.3)};
    text-underline-offset: 3px;
  }
`;
